import { render, staticRenderFns } from "./MobileHome.vue?vue&type=template&id=49ed3ed0&scoped=true"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"
import style0 from "./MobileHome.vue?vue&type=style&index=0&id=49ed3ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed3ed0",
  null
  
)

export default component.exports